<template>
  <div class="boxbgcolor ioRecord">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div v-show="showList" class="form-group">
            <label for="bdate">收费员:</label>
            <el-select v-model="search.chargeUser" multiple collapse-tags placeholder="请选择">
              <el-option
                v-for="item in chargeUserByGroupIdData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div v-show="showList" class="form-group">
            <label for="bdate">开始时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.beginTime"
              type="date"
            ></el-date-picker>
          </div>
          <div v-show="showList" class="form-group">
            <label for="bdate">结束时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd"
              v-model="search.endTime"
              type="date"
            ></el-date-picker>
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <span class="download_btn">
              <button @click="downloadExcel" type="button" class="btn btn-primary">导出EXCEl</button>
            </span>
          </div>

          <div v-show="showChart" class="form-group">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <span class="download_btn">
              <button @click="downloadExcel" type="button" class="btn btn-primary">导出EXCEl</button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <!-- <div class="right content-right" > -->
        <div v-show="showChart" id="myChart" style="width:1000px;height:450px;"></div>
        <div v-show="showList" class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column show-overflow-tooltip label="统计时间" prop="date"></el-table-column>
            <el-table-column label="收费总额">
              <el-table-column show-overflow-tooltip label="收入总额" prop="realMoney"></el-table-column>
              <el-table-column show-overflow-tooltip label="微信" prop="wechat"></el-table-column>
              <el-table-column show-overflow-tooltip label="支付宝" prop="alipay"></el-table-column>

              <el-table-column show-overflow-tooltip label="现金" prop="cash"></el-table-column>
            </el-table-column>

            <el-table-column label="总追缴欠费">
              <el-table-column show-overflow-tooltip label="追缴欠费(总额)" prop="arrears"></el-table-column>
              <el-table-column show-overflow-tooltip label="追缴欠费(支付宝)" prop="arrearsAlipay"></el-table-column>
              <el-table-column show-overflow-tooltip label="追缴欠费(微信)" prop="arrearsWechat"></el-table-column>
              <el-table-column show-overflow-tooltip label="追缴欠费(现金)" prop="arrearsCash"></el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <!-- </div> -->
      </template>
      <!-- <Page :pageSize="search.pageSize"></Page> -->
      <Page v-show="showList" v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getParkingDayReportList,
  getParkingDayList,
  getUserStatistics,
  requestChargeUserByGroupId
} from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
// import Refresh from '../commons/refresh.vue';
export default {
  data() {
    return {
      treeData: {
        groupId: ""
      },
      //根据集团Id获取收费员
      chargeUserByGroupIdData: [],
      moduleName: "property",
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      switchValue: "list",
      showList: true,
      showChart: false,
      showTimeDay: true,
      showTimeMonth: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginTime: "",
        endTime: "",
        chargeUser: ""
        // year: "",
        // month: ""
      },
      value4: "",
      tableListData: [],
      tableListDataTitle: [],
      myChart: {
        title: {
          text: " ",
          subtext: " ",
          x: "center",
          align: "right"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        legend: {
          data: ["收入总额", "未缴费", "追缴欠费(总额)"]
        },
        grid: {
          left: "3%",
          right: "4%",
          // bottom: '3%',
          containLabel: true
        },
        toolbox: {
          // feature: {
          // 	saveAsImage: {}
          // }
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              rotate: 40,
              color: "#333333"
            },
            name: "日期",
            data: []
          }
        ],
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "收入总额",
            type: "line",
            data: []
          },
          {
            name: "未缴费",
            type: "line",
            data: []
          },
          {
            name: "追缴欠费(总额)",
            type: "line",
            data: []
          }
        ]
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择集团！"
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.search.beginTime = "";
      this.search.endTime = "";
      this.search.chargeUser = "";
      if (node.type == "group") {
        this.treeData.groupId = node.id;
        this.search.pageNumber = 1;
        this.chargeUserByGroupId();
        this.tableList(this.search.pageNumber);
        // this.echarts();
      } else {
        this.treeData.groupId = "";
        this.tableListData = [];
        var pageObj = {
          curIndex: 1,
          rowsCount: 0
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        //  this.$message({
        // 	message: '请选择车场！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.$get(getUserStatistics(), {
        page: curPage,
        limit: this.search.pageSize,
        groupId: this.treeData.groupId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
        chargeIds: this.search.chargeUser.toString()
      }).then(data => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },

    searchList: function() {
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.beginTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      if (this.treeData.groupId) {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.$message({
          message: "请选择集团！",
          type: "warning"
        });
      }
    },
    timeCompare: function(bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }

      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    downloadExcel() {
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择集团"
        });
        return;
      }
      this.$downloadFileRequest("/api/parking/parkingOrders/userStatisticsExport", {
        groupId: this.treeData.groupId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
        chargeIds: this.search.chargeUser.toString()
      },
      '收费员收费统计'
      );
    },
    chargeUserByGroupId() {
      this.$get(requestChargeUserByGroupId(), {
        groupId: this.treeData.groupId
      }).then(data => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.chargeUserByGroupIdData = data.data;
      });
    }
  },
  computed: {
    ...mapState({
      curIndex: state => state.page.curIndex,
      rowsCount: state => state.page.rowsCount,
      nodeData: state => state.nodeData,
      nod: state => state.nod
    })
  },
  components: {
    Page,
    AreaTree
  },

  mounted: function() {},
  watch: {}
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
</style>
<style>
.ioRecord .el-select {
  width: 150px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>